<template>
    <div class="search-container">
      <label for="search">Поиск:</label>
      <input
        id="search"
        type="text"
        placeholder="Введите текст для поиска"
        v-model="searchText"
        @input="$emit('search', searchText)"
      />
    </div>
</template>
  
<script>
  export default {
    data() {
      return {
        searchText: "",
      };
    },
  };
</script>

<style scoped>
  .search-container {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 15px;
  }

  .search-container input {
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 300px;
    font-size: 14px;
  }

  .search-container input:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
</style>